import { useState } from "react";

//material-ui
import { Box, Button, Collapse, Grid, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

interface JobDetailProps {
	JobSummary: JobSummary;
	cancelCount: () => void;
}
const JobDetail = ({ JobSummary, cancelCount }: JobDetailProps) => {
	const [detailsOpen, setDetailsOpen] = useState(false);

	if (!JobSummary?.DeviceID) return null;

	return (
		<>
			<Typography variant="h4">
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
					}}
				>
					<Box>
						JobID: <b>{JobSummary.JobID || "-"}</b>
					</Box>
					<Button onClick={() => setDetailsOpen(!detailsOpen)} variant="text" size="small" color="secondary">
						Job Details {detailsOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
					</Button>
				</Box>
			</Typography>
			<Collapse in={detailsOpen}>
				<Grid container spacing={1}>
					<Grid item xs={3} textAlign="right">
						LotID:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.LotID || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Size:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.Size || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Plan:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.Plan || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Cust:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.Customer || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Botanical:
					</Grid>
					<Grid item xs={9}>
						<b>{JobSummary.Botanical || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						RW:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.ReadyWeek || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						SW:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.StartWeek || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Target:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.TargetQuantity || "-"}</b>
					</Grid>
					<Grid item xs={3} textAlign="right">
						Produced:
					</Grid>
					<Grid item xs={3}>
						<b>{JobSummary.CompletedQuantity || "-"}</b>
					</Grid>
					<Grid item xs={12} textAlign="right">
						<Button variant="contained" color="secondary" onClick={cancelCount}>
							Cancel Count
						</Button>
					</Grid>
				</Grid>
			</Collapse>
		</>
	);
};

export default JobDetail;
